"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lang_service_1 = __importDefault(require("../../services/lang.service"));
var sanitize_html_1 = __importDefault(require("sanitize-html"));
;
var EpisodePassword = (function (_super) {
    __extends(EpisodePassword, _super);
    function EpisodePassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            password: "",
            isPasswordIncorrect: false,
        };
        _this.handleChange = function (evt) {
            var target = evt.target;
            if (target === null || target === void 0 ? void 0 : target.name)
                _this.setState(function (prevState) {
                    var _a;
                    return (_a = {},
                        _a[target.name] = target.value,
                        _a);
                });
        };
        _this.submitFormHandler = function (evt) {
            evt.preventDefault();
            var password = _this.state.password;
            var _a = _this.props, episode = _a.episode, onPasswordVerified = _a.onPasswordVerified;
            if (password === episode.password) {
                onPasswordVerified();
            }
            else {
                _this.setState({
                    password: '',
                    isPasswordIncorrect: true,
                });
            }
        };
        return _this;
    }
    EpisodePassword.prototype.sanitizeContent = function (content) {
        var styledContent = content
            .replace(/(?:\r\n|\r|\n)/g, '<br />')
            .replace(/<br \/><br \/>/g, '</p><p>');
        styledContent = "<p>".concat(styledContent, "</p>");
        return {
            __html: (0, sanitize_html_1.default)(styledContent, {
                allowedTags: ['a', 'p', 'br', 'b', 'i', 'em', 'strong'],
                disallowedTagsMode: 'recursiveEscape',
            }),
        };
    };
    EpisodePassword.prototype.render = function () {
        var episode = this.props.episode;
        var _a = this.state, password = _a.password, isPasswordIncorrect = _a.isPasswordIncorrect;
        var getLabel = lang_service_1.default.getLabel;
        return (react_1.default.createElement("div", { className: "episode-password" },
            react_1.default.createElement("div", { className: "episode-password__window" },
                react_1.default.createElement("h1", { className: "episode-password__title" }, getLabel(episode.protectionTitle || 'episodePasswordTitle')),
                react_1.default.createElement("div", { className: "episode-password__content", dangerouslySetInnerHTML: this.sanitizeContent(getLabel(episode.protectionReason || 'episodePasswordDefaultContent', true)) }),
                react_1.default.createElement("form", { className: "episode-password__form", onSubmit: this.submitFormHandler },
                    (episode.password !== '') &&
                        react_1.default.createElement("div", { className: "field-group one-half" },
                            react_1.default.createElement("div", { className: "form-element" },
                                react_1.default.createElement("label", { className: "hidden", htmlFor: "comment-author" }, "Author"),
                                react_1.default.createElement("input", { placeholder: getLabel('passwordPhd'), id: "episode-password", type: "text", name: "password", onChange: this.handleChange, value: password }),
                                isPasswordIncorrect
                                    ? react_1.default.createElement("p", { className: "form-element__hint color-error" }, getLabel('passwordIncorrect'))
                                    : react_1.default.createElement(react_1.default.Fragment, null))),
                    react_1.default.createElement("div", { className: "form-actions" },
                        react_1.default.createElement("button", { className: "btn", type: "submit" }, getLabel('continueBtn')))))));
    };
    return EpisodePassword;
}(react_1.Component));
exports.default = EpisodePassword;
